import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import styles from './index.module.scss';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoImg from 'eco-design/base/eco-img';
import { useState } from 'react';
import { useMediaDevice } from '@elem/compPage/Oasis/hooks';
import EfSection from '@elem/ui/ef-section';

interface ItemType {
    title: string;
    subtitle: string;
    desc: string;
    pc: string;
    h5: string;
}

const JE: React.FC = () => {
    const { t } = useLang('delta3series');
    const [active, setActive] = useState('0');
    const { isH5 } = useMediaDevice();
    const items: ItemType[] = [
        {
            title: t('E_item1_title'),
            subtitle: t('E_item1_subtitle'),
            desc: t('E_item1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740711035257/Group%20161269132%20(2).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1740710953890/EcoFlow%20X-Quiet.jpg',
        },
        {
            title: t('E_item2_title'),
            subtitle: t('E_item2_subtitle'),
            desc: t('E_item2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740711016258/Group%20161269132%20(1)%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1740710953703/EcoFlow%20X-Quiet%20(1).jpg',
        },
    ];

    const tabs: EcoTabItemProps[] = [
        {
            tabValue: '0',
            tabLabel: t('E_tab1'),
        },
        {
            tabValue: '1',
            tabLabel: t('E_tab2'),
        },
    ];

    return (
        <div className={styles.comp} id="d3-E">
            <EcoSpace />
            <EfSection label={t('E_label')} title={t('E_title')} />
            <EcoSpaceSmall />
            <div className="box">
                {!isH5 && (
                    <div className="inner">
                        <div className="img-box">
                            <EcoImg pc={items[Number(active)].pc} pad={items[Number(active)].pc} h5={items[Number(active)].h5} />
                        </div>
                        <div className="info">
                            <p className="title">{items[Number(active)].title}</p>
                            <p className="subtitle">{items[Number(active)].subtitle}</p>
                            <p className="desc">{items[Number(active)].desc}</p>
                        </div>
                    </div>
                )}
                {isH5 &&
                    items.map((item, index) => {
                        return (
                            <div className={`inner inner-${index}`}>
                                <div className="img-box">
                                    <EcoImg pc={item.pc} pad={item.pc} h5={item.h5} />
                                    <div className="inner-interval"></div>
                                </div>
                                <div className="info">
                                    <p className="title">{item.title}</p>
                                    <p className="subtitle">{item.subtitle}</p>
                                    <p className="desc">{item.desc}</p>
                                </div>
                            </div>
                        );
                    })}
            </div>
            {!isH5 && <EcoTab items={tabs} onChange={(item: EcoTabItemProps) => setActive(item.tabValue)} />}
        </div>
    );
};

export default JE;
